import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router';
import 'bootstrap/dist/css/bootstrap.css';
import '../css/trimmis.scss';

export default class ArticleBanner extends Component {
    render() {
        const bannerStyle  = {
            backgroundColor: this.props.color
        };
        const imgContainerStyle = {
            height: "300px"
        };
        const textStyle = {
            fontSize: '32px'
        };
        const buttonStyle = {
            width: '30%'
        };

        const elementClass = (clazzImageIsAlignedRight) => {
            if(this.props.imageAligned === "left") {
                return "col-xs-12 col-sm-6 no-padding left-side-border-radius xs-center";
            } else {
                return "col-xs-12 col-sm-6 "+clazzImageIsAlignedRight+" no-padding xs-center";
            }
        };
        const imageClass = () => {
            return this.props.imageAligned === "left" ? "left-side-border-radius full-size" : "right-side-border-radius full-size";
        };

        return (
            <div className="equal-height-row trimmis-article-banner content-margin-20" style={bannerStyle}>
                <div className={elementClass('col-md-push-6')} style={imgContainerStyle}>
                    <img alt="for-article" src={this.props.image} className={imageClass()}/>
                </div>
                <div className={elementClass('col-md-pull-6')} style={imgContainerStyle}>
                    <h3 style={textStyle}>{this.props.title}</h3>

                    <Link to={"#"} className="info-button-reverse xs-margin-bottom-10" style={buttonStyle}>
                        <FormattedMessage
                            id="button.label.read_more"
                            defaultMessage={'*Read more*'}
                        />
                    </Link>
                </div>
                <div className="clearfix"></div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ../components/ArticleBanner.js